@if (!isCalculator) {
  <div
    class="h-full mobi-ui-card-major mobi-ui-relative mobi-ui-ink-black mobi-ui-padding-b-xl"
  >
    <div class="mobi-ui-card-content-major mobi-ui-margin-t-sm">
      @if (title) {
        <h4 class="mobi-ui-font-size-400">
          @if (!isDealer) {
            <span class="block font-bold mobi-ui-font-size-50 mb-2 text-black">
              {{ 'your' | texts: { context: 'primcalc', default: 'Ihre' } }}
            </span>
          }
          {{ title }}
        </h4>
      }
      <ul class="mobi-ui-list-silent mobi-ui-margin-t-xxs">
        @for (item of entries; track $index) {
          <li class="mobi-ui-text-block-major">
            <mobi-ui-icon-major [name]="item.icon" size="md" />
            <div class="mobi-ui-text-block-content-major">
              <span class="mobi-ui-text-block-label-major">
                {{ item.label }}
              </span>
              @if (item.text) {
                <p
                  class="mobi-ui-text-block-content-major mobi-ui-text-break hyphens-auto"
                >
                  {{ item.text }}
                </p>
              }
            </div>
          </li>
        }
      </ul>
    </div>
    @if (action) {
      <button class="mobi-ui-btn-minor mobi-ui-margin-t-md" (click)="action()">
        {{ 'edit' | texts: { context: 'primcalc', default: 'Anpassen' } }}
      </button>
    }
  </div>
} @else {
  <webform-calc
    [callOnChange]="false"
    [element]="calculatorElement"
    [isSummary]="true"
    [action]="action"
  ></webform-calc>
}
